import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useRandomId from 'hooks/useRandomId';
import { colorGray } from 'styles/layout/colors';
const IconMapMarkerWithBase = t0 => {
  const $ = _c(15);
  const {
    color: t1,
    height: t2,
    title: t3,
    width: t4
  } = t0;
  const color = t1 === undefined ? colorGray : t1;
  const height = t2 === undefined ? 16 : t2;
  const title = t3 === undefined ? "location" : t3;
  const width = t4 === undefined ? 13 : t4;
  const titleId = useRandomId("IconMapMarkerWithBase__title");
  let t5;
  if ($[0] !== title) {
    t5 = <title>{title}</title>;
    $[0] = title;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  let t7;
  if ($[2] !== color) {
    t6 = <path d="M10.8511 4.35328C10.8511 1.94901 8.90208 0 6.49781 0C4.09354 0 2.14453 1.94901 2.14453 4.35328C2.14453 6.75755 6.49781 13.5436 6.49781 13.5436C6.49781 13.5436 10.8511 6.75755 10.8511 4.35328ZM5.04666 4.43421C5.04666 3.63296 5.69639 2.98305 6.49781 2.98305C7.29923 2.98305 7.94896 3.63278 7.94896 4.43421C7.94896 5.23563 7.29923 5.88536 6.49781 5.88536C5.69639 5.88536 5.04666 5.23563 5.04666 4.43421Z" fill={color} />;
    t7 = <path d="M9.89752 11.058C9.51392 10.9357 9.10732 11.1487 8.98682 11.5303C8.86543 11.9125 9.07702 12.3202 9.45919 12.441C10.4861 12.7665 10.8319 13.1613 10.8319 13.2913C10.8319 13.656 9.31374 14.5478 6.49896 14.5478C3.68435 14.5478 2.166 13.656 2.166 13.2913C2.166 13.1613 2.51127 12.7671 3.53729 12.4416C3.91911 12.3207 4.13052 11.9125 4.00948 11.5309C3.88827 11.1483 3.48043 10.9377 3.09861 11.0585C1.02447 11.7161 0.714844 12.7396 0.714844 13.2913C0.714844 15.0688 3.62464 15.9989 6.49896 15.9989C9.37327 15.9989 12.2831 15.0688 12.2831 13.2913C12.2829 12.7396 11.9731 11.7161 9.89752 11.058Z" fill={color} />;
    $[2] = color;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7) {
    t8 = <g>{t5}{t6}{t7}</g>;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== height || $[10] !== t8 || $[11] !== title || $[12] !== titleId || $[13] !== width) {
    t9 = <svg aria-labelledby={titleId} aria-hidden="true" fill="none" height={height} title={title} viewBox="0 0 13 16" width={width}>{t8}</svg>;
    $[9] = height;
    $[10] = t8;
    $[11] = title;
    $[12] = titleId;
    $[13] = width;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
IconMapMarkerWithBase.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  title: PropTypes.string,
  width: PropTypes.number
};
export default IconMapMarkerWithBase;